module.exports = __webpack_public_path__ + "img/arrow-bar-left.c4e6c2ec.svg";